export var domainApiRelativePath = "/helpcenter/domain";
export var createDomainApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + domainApiRelativePath;
    return {
        getDomainSettings: function (brandId) {
            return http.get("" + apiUrl + (brandId ? "?brandId=" + brandId : ''));
        },
        linkDomain: function (dto) { return http.put(apiUrl + "/connect", dto); },
        unlinkDomain: function (brandId) { return http.put(apiUrl + "/disconnect", { brandId: brandId }); },
        checkDomainStatus: function (domain) { return http.get(apiUrl + "/check?domain=" + domain); }
    };
};
//# sourceMappingURL=index.js.map